import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToastCaution = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M21.266 21.4981H2.73301C2.37575 21.4981 2.04563 21.3075 1.867 20.9981C1.68837 20.6887 1.68838 20.3075 1.86701 19.9981L11.133 3.99811C11.3118 3.68923 11.6416 3.49902 11.9985 3.49902C12.3554 3.49902 12.6852 3.68923 12.864 3.99811L22.13 19.9981C22.3085 20.3074 22.3086 20.6883 22.1303 20.9977C21.9519 21.307 21.6221 21.4977 21.265 21.4981H21.266ZM12 6.49811L4.46901 19.4981H19.533L12 6.49811ZM12.995 15.4991H10.995V10.4981H12.995V15.4991Z",
		fill: "#FFBC03"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M11 16.5001H13V18.5001H11V16.5001Z",
		fill: "#FFBC03"
	})]
});
export { SvgToastCaution as ReactComponent };
